
/**
 * 1、特殊处理text标签
 * 2、移除sodipodi标签
 * 3、移除sodipodi属性
 * 4、纯文本方式解决
 */

//下载
export function download(url, filename) {
    const a = document.createElement('a');
    a.download = filename;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}


export function svg2CanvasExt(svgNode,callback) {
    const svgString = new XMLSerializer().serializeToString(svgNode);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.setAttribute("width", svgNode.clientWidth + "px");
    canvas.setAttribute("height", svgNode.clientHeight + "px");
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.onload = function () {
        ctx.drawImage(img, 0, 0);
        callback(canvas);
    };
    img.src = svgUrl;
    img.onerror = function (err) {
        console.log(err);
    };
}

export function svg2Canvas(svgNode, callback) {
    const svgString = new XMLSerializer().serializeToString(svgNode);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.setAttribute("width", svgNode.clientWidth + "px");
    canvas.setAttribute("height", svgNode.clientHeight + "px");
    canvas.setAttribute("style", "display:block;");
    const img = new Image();
    img.onload = function () {
        ctx.drawImage(img, 0, 0);
        callback(canvas);
    };
    img.onerror = function (err) {
        console.log(err);
    };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgString)));
}